// components
import {
  styled,
  Box,
  BoxProps,
  Typography,
  TypographyProps
} from '@mui/material';

export const StyledRelativeBox = styled(Box)<BoxProps>(() => ({
  position: 'relative'
}));

export const StyledFilterSectionTypography = styled(
  Typography
)<TypographyProps>(({ theme }) => ({
  width: '100%',
  textTransform: 'uppercase',
  color: theme.palette.grey[600],
  letterSpacing: theme.spacing(0.25)
}));

export const StyledFilterSectionWithMarginTopTypography = styled(
  StyledFilterSectionTypography
)<TypographyProps>(({ theme }) => ({
  marginTop: theme.spacing(4)
}));
